import { observer } from 'mobx-react-lite';
import React from 'react';

import { Icon, IconClose } from '@flixbus/honeycomb-icons-react';
import { Input, Button } from '@flixbus/honeycomb-react';

import { rideFilterStore } from 'pages/RideListPage/components/RideFilters/RideFilterStore';

import { buildTimeViewData } from './buildTimeViewData';
import { TIME_FILTER_TEXT } from './texts';

const TimeForDaterange = observer(({ extraClasses }) => {
	const dateRangeValue = rideFilterStore.filtersMap.get('departureRange')?.value;
	const { shownValue, disabled, showResetIcon } = buildTimeViewData(dateRangeValue);

	const handleChange = (e) => {
		if (!e.isTrusted) {
			return;
		}
		rideFilterStore.handleDateRangeChange(
			{ from: dateRangeValue.from, to: dateRangeValue.to },
			e.target.value
		);
	};

	const handleReset = () => {
		rideFilterStore.handleDateRangeChange({ from: dateRangeValue.from, to: dateRangeValue.to });
	};

	const inputProps = {
		ref: null,
		id: 'departure-time',
		label: TIME_FILTER_TEXT.inputLabel,
		type: 'time',
	};
	if (showResetIcon) {
		inputProps.iconRight = (
			<Button onClick={handleReset}>
				<Icon InlineIcon={IconClose} />
			</Button>
		);
	}

	return (
		<Input
			value={shownValue}
			disabled={disabled}
			onChange={handleChange}
			{...inputProps}
			extraClasses={extraClasses}
		/>
	);
});

export default TimeForDaterange;
